import { call, put, takeEvery } from 'redux-saga/effects';
import * as type from '../../ActionTypes';
import { getRecentMessageService } from '../../../services/chat';

function* getRecentMessage(action: any): any {
  try {
    const message = yield call(getRecentMessageService);
    if (message.status === 200) {
      yield put({
        type: type?.GET_RECENT_MESSAGE_SUCCESS,
        message: message.data
      });
    } else {
      yield put({
        type: type?.GET_RECENT_MESSAGE_ERROR
      });
    }
  } catch (e: any) {
    yield put({
      type: type?.GET_RECENT_MESSAGE_ERROR,
      error: e.message
    });
  }
}

function* chatSaga() {
  yield takeEvery(type.GET_RECENT_MESSAGE_REQUEST, getRecentMessage);
}

export default chatSaga;
